<div class="order-details-info" *transloco="let t;">
    <div class="order-details-information" 
        [style.padding-left]="isInCheckout() ? '0' : ''"
        [style.padding-right]="isInCheckout() ? '0' : ''"
    >
        <div class="order-details">
            <cwo-icon-label-value [iconName]="iconNameType.store" [attr.tabindex]="parentExpanded() ? 0 : -1" [label]="t('shared_components.order_details_information.store')" [value]="store()?.address" />
            @if(store()?.hasStoreChooser && !isInCheckout()){
                <button class="button-undecorated" (click)="handleEditStore()">
                    <cwo-icon [name]="iconNameType.edit" class="edit-icon"/>
                </button>
            }
        </div>
        <cwo-icon-label-value [iconName]="iconNameType.orderType" [attr.tabindex]="parentExpanded() ? 0 : -1" [label]="t('shared_components.order_details_information.order_type')" [value]="orderType()" />
        @if (address()) {
        <cwo-icon-label-value [iconName]="calcAddressIcon()" [attr.tabindex]="parentExpanded() ? 0 : -1" [label]="addressLabel()" [value]="address()" />
        }
        <cwo-icon-label-value [iconName]="iconNameType.clock" [attr.tabindex]="parentExpanded() ? 0 : -1" [label]="t('shared_components.order_details_information.schedule')" [value]="'TEST'">
            <ng-template #valueRef>
                <cwo-dotted-labels [fontSize]="'var(--font-size-med)'" [lineHeight]="'1.25rem'" [fontWeight]="'var(--font-weight-medium)'"
                    [labels]="scheduleInfoLabels()" [gap]="'10px'"/>
            </ng-template>
        </cwo-icon-label-value>
    </div>
    @if(!isInCheckout()){
        <div class="buttons">
            <cwo-accent-button [ariaLabel]="t('shared_components.order_details_information.change')" [fontSize]="'large'" [fullWidth]="true"
                [accentButtonStyle]="accentButtonStyleType.SOFT" (click)="handleChangeOrderDetails()">
                <span class="action-button">{{t('shared_components.order_details_information.change')}}</span>
            </cwo-accent-button>
            <cwo-accent-button [ariaLabel]="t('shared_components.order_details_information.done')" [fontSize]="'large'" [fullWidth]="true" (click)="handleDone()">
                <span class="action-button">{{t('shared_components.order_details_information.done')}}</span>
            </cwo-accent-button>
        </div>
    }
</div>